<!-- 省级总代管理 -->
<template>
  <div class="distributor">
    <el-row class="tableHearInputBox"
            type="flex"
            justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query"
                  placeholder="请输入省份名称"
                  style="width: 200px; margin-right:10px"
                  @keyup.enter.native="tableLoad"
                  @clear="
            query.query = '';
            tableLoad();
          "
                  clearable
                  suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button size="small"
                     @click="tableLoad">查询</el-button>
        </Debounce>
      </el-col>
      <el-button type="primary"
                 size="small"
                 @click="operatInfo(1)"
                 v-if="$roleFilter('province::add')">添加</el-button>
      <el-button type="primary"
                 size="small"
                 @click="exportExcel"
                 v-if="$roleFilter('province::export')">导出</el-button>
    </el-row>
    <el-table :data="tableList"
              tooltip-effect="dark"
              border
              ref="elTable"
              style="width: 100%;"
              :header-cell-style="$store.getters.getTableHeadStyle"
              v-loading="tableIsLoad"
              element-loading-text="加载中"
              :height="$store.getters.getTableHeight">
      <el-table-column prop="provinceName"
                       label="省份名称"
                       align="center"></el-table-column>
      <el-table-column prop="correlationTest"
                       label="关联市级代理（个）"
                       align="center"></el-table-column>

      <el-table-column prop="principalName"
                       label="省级管理员"
                       align="center"></el-table-column>
      <el-table-column prop="mobile"
                       label="联系电话"
                       align="center"></el-table-column>
                       <el-table-column prop="zybm"
                       v-if="tableList&&tableList.length>0&&(tableList[0].zybm==0||tableList[0].zybm==1)"
                       label="是否开放自由报名"
                       align="center">
                       <template slot-scope="scope">
                     
                          <el-switch v-model="scope.row.zybm"
                         active-text="是"
                         active-color="#409eff"
                inactive-color="#c0c4cc"
                 
                         @change="releaseSwitch(scope.row)"
                         :active-value="1"
                         inactive-text="否"
                         :inactive-value="0"
                         class="my-switch"
                        ></el-switch>
            </el-radio-group>

                       </template>
                      </el-table-column>
      <el-table-column label="操作"
                       align="center">
        <template slot-scope="scope">
          <el-button type="text"
                     class="tableContentUpdateBut"
                     @click="operatInfo(2, scope.row)"
                     v-if="$roleFilter('province::update')">修改</el-button>
          <span style="margin: 0px 5px;"
                v-if="$roleFilter('province::update') && $roleFilter('province::delete')">|</span>
          <el-button type="text"
                     class="tableContentRemoveBut"
                     @click="operatInfo(0, scope.row)"
                     v-if="$roleFilter('province::delete')">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total"
                :page.sync="query.pageNum"
                :limit.sync="query.pageSize"
                class="pagination-content"
                @pagination="tableLoad" />
    <el-dialog custom-class="dailogComponents"
               :title="visibleType == 1 ? '添加' : '修改'"
               :visible.sync="visible"
               :destroy-on-close="true"
               :close-on-click-modal="false"
               width="360px">
      <div v-if="visible"
           class="dialogBox">
        <el-row type="flex"
                class="dialogTitle"
                justify="space-between">
          <el-col :span="10">
            <p><span style="color:red;">*</span>省份名称:</p>
          </el-col>
          <el-col :offset="1">
            <el-input v-model="visibleObj.provinceName"
                      placeholder="请输入省份名称" />
            <!-- <el-select v-model="visibleObj.provinceId" filterable placeholder="请选择">
              <el-option v-for="item in examineeList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
          </el-col>
        </el-row>
        <el-row type="flex"
                class="dialogTitle"
                justify="space-between">
          <el-col :span="10">
            <p><span></span>省级管理员:</p>
          </el-col>
          <el-col :offset="1">
            <el-select v-model="visibleObj.principal"
                       filterable
                       @clear="clearAdmin"
                       placeholder="请选择"
                       clearable
                       style="width:100%">
              <el-option v-for="item in userList"
                         :key="item.userId"
                         :label="item.userName + '(' + item.name + ')'"
                         :value="item.userId">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row type="flex"
                class="dailogButBox"
                justify="center">
          <el-col :span="7">
            <el-button size="medium"
                       @click="visible = false">取消</el-button>
          </el-col>
          <el-col :span="4">
            <el-button size="medium"
                       type="primary"
                       @click="submit">确认</el-button>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { exportFile } from "@/uitls/globalFun.js";
export default {
  data() {
    return {
      tableList: [],
      tableIsLoad: true,
      userList: [],
      examineeList: [],
      visible: false,
      visibleType: 0, //删除
      visibleObj: {
        principal: null, //负责人
        provinceId: "", //省份id
        provinceName: "", //省份名称
      },
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
      },
    };
  },
  mounted() {
    this.getAllUser();
    this.tableLoad();
  },
  methods: {
    clearAdmin() {
      this.visibleObj.principal = null;
    },
    releaseSwitch(row) {
      console.log(row);
      this.$axios
        .put(`/province/${row.id}/${row.zybm}`)
        .then((res) => {
          this.$message({
                type: "success",
                message: "操作成功!",
               
              });
              this.tableLoad();
        });
      // this.times = []
    },
    //导出
    exportExcel() {
      this.$axios
        .post("/province/export", this.query, { responseType: "blob" })
        .then((res) => {
          exportFile(res);
        });
    },
    tableLoad() {
      this.tableIsLoad = true;
      this.$axios.post("/province/list", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list;
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    getAllUser() {
      this.$axios.get("/user/province/select").then((res) => {
        this.userList = res.data.data;
      });
      this.$axios.get("province/selectProvince").then((res) => {
        this.examineeList = res.data.data;
      });
    },
    operatInfo(type, row) {
      this.visibleType = type;
      this.visibleObj = {
        principal: null, //负责人
        provinceName: "", //省份名称
        provinceId: "", //省份ID
      };
      if (type === 0) {
        //删除
        let context = row.gridDelete
          ? "是否删除数据？"
          : "该省份已关联" +
            row.correlationTest +
            "个市代，删除后相关市代要重新关联省份，是否继续删除？";
        this.$dailog({
          title: "删除",
          context,
          callbackFun: () => {
            this.$axios.delete("/province/" + row.id).then((res) => {
              this.$message({
                type: "success",
                message: "操作成功!",
                duration: 1000,
              });
              this.tableLoad();
            });
          },
        });
      } else if (type === 1) {
        //添加
        this.visible = true;
      } else {
        //修改
        this.visibleObj = {
          principal: row.principal, //负责人
          // provinceId: selectObj.value + '', //省份id
          provinceName: row.provinceName, //省份名称
          id: row.id,
        };
        this.visible = true;
      }
    },
    submit() {
      if (!this.visibleObj.provinceName) {
        this.$message({
          type: "warning",
          message: "必填项不能为空!",
          duration: 1000,
        });
        return;
      }
      let subType = this.visibleType === 1 ? "post" : "put";
      let url =
        this.visibleType === 1
          ? "/province"
          : "/province/" + this.visibleObj.id;
      this.$axios({
        method: subType,
        url: url,
        data: this.visibleObj,
      }).then((res) => {
        this.$message({
          type: "success",
          message: "保存成功!",
          duration: 1000,
        });
        this.visible = false;
        this.tableLoad();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .my-switch {
        position: absolute;
        top: 50%;
        left: 65%;
        margin-left: -90px;
        margin-top: -10px;
        .el-switch__label {
          position: absolute;
          display: none;
          color: #fff;
        }
        .el-switch__label--left {
          z-index: 9;
          left: 20px;
        }
        .el-switch__label--right {
          z-index: 9;
          left: -4px;
        }
        .el-switch__label.is-active {
          display: block;
        }
        .el-switch .el-switch__core,
        .el-switch .el-switch__label {
          width: 50px !important;
        }
      }
    
    
</style>
